import { render, staticRenderFns } from "./CommunicateModal.vue?vue&type=template&id=02d9f6e7&scoped=true"
import script from "./CommunicateModal.vue?vue&type=script&lang=js"
export * from "./CommunicateModal.vue?vue&type=script&lang=js"
import style0 from "./CommunicateModal.vue?vue&type=style&index=0&id=02d9f6e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d9f6e7",
  null
  
)

export default component.exports